var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-3" }, [
        _vm.journey
          ? _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c("navigate-to-actionable-report-link", {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { "journey-id": _vm.journey.id }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-auto" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-outline-secondary",
              attrs: { href: "/JourneyBuilder/Overview" }
            },
            [
              _c("i", { staticClass: "fas fa-route" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.resource("JourneyBuilder_Index_Overview_Button_Text")
                  ) +
                  "\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("bootstrap-box", {
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _vm.journey
                  ? [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-3 menu-container",
                            class: { collapsed: !_vm.showMenu }
                          },
                          [
                            _c("toggle-button", {
                              staticClass: "menu-toggle",
                              attrs: {
                                sync: true,
                                labels: {
                                  checked: _vm.resource("Bool_Expand"),
                                  unchecked: _vm.resource("Bool_Collapse")
                                },
                                width: 78
                              },
                              model: {
                                value: _vm.showMenu,
                                callback: function($$v) {
                                  _vm.showMenu = $$v
                                },
                                expression: "showMenu"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "menu-wrapper" },
                              [
                                _c("menu-area", {
                                  attrs: {
                                    "journey-id": _vm.journey.id,
                                    "journey-name": _vm.journey.name,
                                    "journey-world": _vm.journey.worldId,
                                    "journey-type": _vm.journey.type,
                                    "journey-description":
                                      _vm.journey.description,
                                    "journey-start-date": _vm.journey.startDate,
                                    "journey-end-date": _vm.journey.endDate,
                                    "journey-is-active": _vm.journey.isActive,
                                    "journey-division-id":
                                      _vm.journey.divisionId
                                  },
                                  on: {
                                    "update:journeyName": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "name",
                                        $event
                                      )
                                    },
                                    "update:journey-name": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "name",
                                        $event
                                      )
                                    },
                                    "update:journeyWorld": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "worldId",
                                        $event
                                      )
                                    },
                                    "update:journey-world": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "worldId",
                                        $event
                                      )
                                    },
                                    "update:journeyType": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "type",
                                        $event
                                      )
                                    },
                                    "update:journey-type": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "type",
                                        $event
                                      )
                                    },
                                    "update:journeyDescription": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "description",
                                        $event
                                      )
                                    },
                                    "update:journey-description": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "description",
                                        $event
                                      )
                                    },
                                    "update:journeyStartDate": [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.journey,
                                          "startDate",
                                          $event
                                        )
                                      },
                                      function($event) {
                                        return _vm.setStartDate($event)
                                      }
                                    ],
                                    "update:journey-start-date": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "startDate",
                                        $event
                                      )
                                    },
                                    "update:journeyEndDate": [
                                      function($event) {
                                        return _vm.$set(
                                          _vm.journey,
                                          "endDate",
                                          $event
                                        )
                                      },
                                      function($event) {
                                        return _vm.setEndDate($event)
                                      }
                                    ],
                                    "update:journey-end-date": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "endDate",
                                        $event
                                      )
                                    },
                                    "update:journeyIsActive": function($event) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "isActive",
                                        $event
                                      )
                                    },
                                    "update:journey-is-active": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "isActive",
                                        $event
                                      )
                                    },
                                    "update:journeyDivisionId": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "divisionId",
                                        $event
                                      )
                                    },
                                    "update:journey-division-id": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.journey,
                                        "divisionId",
                                        $event
                                      )
                                    },
                                    save: _vm.publishJourney,
                                    clone: function($event) {
                                      return _vm.cloneJourney(_vm.journey.id)
                                    },
                                    "add-brick": _vm.addBrickToJourney
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c("canvas-area", {
                              ref: "composer",
                              attrs: {
                                bricks: _vm.journey.bricks,
                                journeyType: _vm.journey.type
                              },
                              on: {
                                "top-left-changed": function($event) {
                                  return _vm.setNewBrickDefaultPosition(
                                    $event.x,
                                    $event.y
                                  )
                                },
                                "brick-moved": function($event) {
                                  return _vm.brickMoved(
                                    $event.brickId,
                                    $event.x,
                                    $event.y
                                  )
                                },
                                "connector-moved": function($event) {
                                  return _vm.connectorMoved(
                                    $event.connectionId,
                                    $event.sourceBrickId,
                                    $event.connectorX,
                                    $event.connectorY
                                  )
                                },
                                "add-brick-at-location": _vm.addBrickAtLocation,
                                delete: function($event) {
                                  return _vm.deleteBrick(
                                    $event.brick.id,
                                    $event.requiresPrompt
                                  )
                                },
                                "add-connection": function($event) {
                                  return _vm.addConnectionToBrick($event.id)
                                },
                                "settings-changed": function($event) {
                                  return _vm.updateSettings(
                                    $event.id,
                                    $event.config,
                                    $event.name
                                  )
                                },
                                "connection-created": function($event) {
                                  return _vm.connectBricks(
                                    $event.connectionId,
                                    $event.sourceBrickId,
                                    $event.destinationBrickId
                                  )
                                },
                                "change-connection": function($event) {
                                  return _vm.changeConnection(
                                    $event.sourceBrickId,
                                    $event.connectionId,
                                    $event.model
                                  )
                                },
                                "delete-connection-checkpoint": function(
                                  $event
                                ) {
                                  return _vm.deleteCheckpoint(
                                    $event.connection,
                                    $event.checkpoint
                                  )
                                },
                                "delete-connection": function($event) {
                                  return _vm.deleteConnection(
                                    $event.sourceBrickId,
                                    $event.destinationBrickId,
                                    $event.connectionId
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _c("loading-box")
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.brickDeletePrompt.show
        ? _c("delete-brick-prompt", {
            attrs: {
              "brick-id": _vm.brickDeletePrompt.brickId,
              title: _vm.resource(
                "JourneyBuilder_Index_DeleteBrick_ConfirmationTitle"
              ),
              body: _vm.resource(
                "JourneyBuilder_Index_DeleteBrick_ConfirmationBody"
              )
            },
            on: {
              yes: function($event) {
                return _vm.deleteBrick(_vm.brickDeletePrompt.brickId, false)
              },
              hidden: function($event) {
                _vm.brickDeletePrompt.show = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }